import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitLines',
})
export class SplitLinesPipe implements PipeTransform {
  transform(value: string): string[] {
    const lines = value
      .split('\n')
      .map((line) => line.trim())
      .filter((line) => line.length > 0);
    return lines;
  }
}
